import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgHomepageInstantPayout = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 19"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M18.742 1.44C11.255-1.168 4.101.353 1.384 1.44c-2.507 7.138-1.044 13.705 0 16.096 7.432 2.651 14.619 1.105 17.358 0 2.278-6.646.95-13.5 0-16.096"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M10.019 15.614a5.594 5.594 0 1 0 0-11.188 5.594 5.594 0 0 0 0 11.188"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M5.283 6.845h-.461a.46.46 0 0 0 .458.461v-.461zm1.566.468a.463.463 0 0 0 .465-.459.463.463 0 0 0-.458-.464zM5.74 5.276a.46.46 0 1 0-.923.006zm-.77 3.978a.461.461 0 0 0-.914-.126zm9.253-3.477c-2.35-2.35-6.151-2.375-8.487-.04l.653.653c1.97-1.97 5.185-1.957 7.179.04l.652-.653zm-8.447 8.446c2.351 2.35 6.152 2.375 8.487.04l-.652-.652c-1.97 1.969-5.185 1.956-7.18-.04l-.651.652zm8.487.04c2.336-2.335 2.311-6.135-.04-8.486l-.652.653c1.997 1.996 2.01 5.211.04 7.177l.652.653zM5.735 5.74l-.778.779.652.652.779-.778zM5.28 7.306l1.566.01.006-.923-1.566-.01zm.465-.464-.01-1.566-.923.006.01 1.566zm-1.69 2.286a6.05 6.05 0 0 0 1.72 5.095l.653-.653a5.11 5.11 0 0 1-1.459-4.316zM8.117 10.555l.88.985a.462.462 0 0 0 .69 0l2.197-2.462a.462.462 0 0 0-.69-.615L9.343 10.54l-.535-.6a.462.462 0 0 0-.69.615"
      />
    </svg>
  );
};
export default SvgHomepageInstantPayout;
